<template>
    <div class="sim-letters-widespread sim-font-bold"
         :class="{
             'sim-text-small': size === 'md',
             'sim-text-extra-small': size === 'sm',
         }"
    >
        <!--  Known availability  -->
        <span v-if="product.hasAvailability(selectedVariation)" class="flex gap-1" :class="!product.isAvailable(selectedVariation) ? 'text-danger-500' : 'text-success-500'">
            <span class="uppercase">
                {{ product.getAvailabilityLabel(selectedVariation) }}
            </span>

            <span v-if="product.isAvailable(selectedVariation) && showStockCount" :class="{ 'text-success-500': product.canBePurchased(selectedVariation) }">
                {{ product.getFormattedStockCount(selectedVariation) }}
            </span>
        </span>

        <!--  Unknown availability  -->
        <span v-else class="text-warning-500 flex gap-1">
            <span class="uppercase">
                {{ $t('product.unknown_availability') }}
            </span>

            <span v-if="product.hasStock(selectedVariation)" :class="{ 'text-success-500': product.canBePurchased(selectedVariation) }">
                {{ product.getFormattedStockCount(selectedVariation) }}
            </span>
        </span>
    </div>
</template>

<script lang="ts" setup>

const {
    product,
    selectedVariation,
    showStockCount = true,
    size = 'md',
} = defineProps<{
    product: InstanceType<typeof ProductModel>
    selectedVariation?: InstanceType<typeof ProductVariationModel> | null
    showStockCount?: boolean
    size?: 'sm' | 'md'
}>()

</script>

<style lang="scss" scoped>

</style>
